import { Component, Input, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DateTime } from 'luxon';

import { IAuroraState } from '@apps/aurora.state';
import * as fromRootStore from '@apps/root/store';
import { DatesService } from '@common/services';

@Component({
    selector: 'aa-range-viewer',
    templateUrl: './range-viewer.component.html',
    styleUrls: [
        './range-viewer.component.scss'
    ],
    standalone: false
})
export class RangeViewerComponent implements OnInit
{
    @Input() rangeClicked: () => void;
    @Input() unclickable = false;
    range: Observable<string[]>;

    constructor (
        private store: Store<IAuroraState>,
        private datesService: DatesService
    )
    {
    }

    ngOnInit ()
    {
        this.range = this.store
            .pipe(
                select(fromRootStore.getRootRangeViewerSinceUntil),
                map((range: DateTime[]) =>
                    this.datesService.displayRangeViewerPeriod(range[0], range[1])
                )
            );
    }

    onClick ()
    {
        if (this.rangeClicked)
        {
            this.rangeClicked();
        }
    }
}
